import { Duration } from "luxon";

/** A call's length, rounded to the nearest minute (e.g. `3m`, `1h 5m`). */
export function renderCallDuration(seconds: number): string {
  if (seconds === 0) {
    return "--";
  }

  const minutes = Math.max(
    1,
    Math.round(Duration.fromObject({ seconds }).as("minutes")),
  );

  return minutes < 60
    ? `${minutes}m`
    : Duration.fromDurationLike({ minutes }).rescale().toFormat("h'h' m'm'");
}

/** A call's length using its two most significant units (e.g. `1h 32m`). */
export function renderCallLength(seconds: number): string {
  const duration = Duration.fromObject({
    seconds: Math.max(0, Math.floor(seconds)),
  }).shiftTo("hours", "minutes", "seconds");

  if (duration.hours > 0) {
    return duration.minutes > 0
      ? `${duration.hours}h ${duration.minutes}m`
      : `${duration.hours}h`;
  }

  if (duration.minutes > 0) {
    return duration.seconds > 0
      ? `${duration.minutes}m ${duration.seconds}s`
      : `${duration.minutes}m`;
  }

  return `${duration.seconds}s`;
}

export function renderDuration(seconds: number): string {
  const duration = Duration.fromMillis(seconds * 1000);

  if (duration.as("hours") >= 1) {
    return duration.toFormat("h:mm:ss");
  }

  return duration.toFormat("m:ss");
}
